"use client";
import { createContext, useContext, useState, ReactNode } from "react";

interface LanguageContextProps {
    language: string;
    toggleLanguage: () => void;
}

const LanguageContext = createContext<LanguageContextProps | undefined>(undefined);

export const LanguageProvider = ({
    children,
    initialLanguage,
}: {
    children: ReactNode;
    initialLanguage: string;
}) => {
    const [language, setLanguage] = useState(initialLanguage);

    const toggleLanguage = () => {
        const newLang = language === "en" ? "id" : "en";

        setLanguage(newLang);

        // ✅ simpan ke cookie (bisa dibaca server)
        document.cookie = `lang=${newLang}; path=/`;
    };

    return (
        <LanguageContext.Provider value={{ language, toggleLanguage }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => {
    const context = useContext(LanguageContext);
    if (!context) {
        throw new Error("useLanguage must be used within a LanguageProvider");
    }
    return context;
};